<template>
  <div>
    <div class="table-tools">
      <h2 class="page-title" style="margin-bottom:0;">企业管理</h2>
      <el-button type="primary" @click="openCreate">新建企业</el-button>
    </div>

    <div class="card-panel" style="padding:20px;">
      <el-table :data="companies" width="100%">
        <el-table-column prop="name" label="企业名称" />
        <el-table-column label="负责人" min-width="180">
          <template slot-scope="scope">
            <span>{{ ownerText(scope.row.owner) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码" min-width="180" />
        <el-table-column prop="legalRepresentative" label="法定代表人" />
        <el-table-column label="认证状态" width="120">
          <template slot-scope="scope">
            <el-tag>{{ statusText(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isActive ? 'success' : 'info'">{{ scope.row.isActive ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="editCompany(scope.row)">编辑</el-button>
            <el-button type="text" style="color:#f56c6c;" @click="removeCompany(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="form.id ? '编辑企业' : '新建企业'" :visible.sync="showDialog" width="720px">
      <el-form :model="form" label-position="top" class="form-grid">
        <el-form-item label="企业名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="负责人">
          <el-select v-model="form.ownerVendorId" filterable placeholder="请选择负责人供应商">
            <el-option v-for="vendor in activeVendors" :key="vendor.id" :label="ownerText(vendor)" :value="vendor.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="统一社会信用代码">
          <el-input v-model="form.unifiedSocialCreditCode" />
        </el-form-item>
        <el-form-item label="法定代表人">
          <el-input v-model="form.legalRepresentative" />
        </el-form-item>
        <el-form-item label="注册地址">
          <el-input v-model="form.registeredAddress" />
        </el-form-item>
        <el-form-item label="经营范围">
          <el-input v-model="form.businessScope" />
        </el-form-item>
        <el-form-item label="营业执照编号">
          <el-input v-model="form.licenseNo" />
        </el-form-item>
        <el-form-item label="认证状态">
          <el-select v-model="form.status">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="执照文件 URL">
          <el-input v-model="form.licenseUrl" />
        </el-form-item>
        <el-form-item label="认证文件 URL">
          <el-input v-model="form.certificateUrl" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.isActive" active-text="启用" inactive-text="停用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createCompany, deleteCompany, getCompanies, getVendors, updateCompany } from '../../api/admin'

const statusOptions = [
  { label: '待认证', value: 'pending' },
  { label: '已认证', value: 'approved' },
  { label: '未通过', value: 'rejected' },
]

const defaultForm = () => ({
  id: null,
  name: '',
  ownerVendorId: null,
  unifiedSocialCreditCode: '',
  legalRepresentative: '',
  registeredAddress: '',
  businessScope: '',
  licenseNo: '',
  licenseUrl: '',
  certificateUrl: '',
  status: 'pending',
  isActive: true,
})

export default {
  data() {
    return {
      statusOptions,
      companies: [],
      vendors: [],
      form: defaultForm(),
      showDialog: false,
    }
  },
  computed: {
    activeVendors() {
      return this.vendors.filter(vendor => vendor.isActive)
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const [companies, vendors] = await Promise.all([getCompanies(), getVendors()])
      this.companies = companies.data
      this.vendors = vendors.data
    },
    ownerText(owner) {
      if (!owner) return '-'
      return `${owner.name}（${owner.shortCode || owner.vendorCode}）`
    },
    statusText(status) {
      const item = statusOptions.find(option => option.value === status)
      return item ? item.label : '待认证'
    },
    openCreate() {
      this.form = defaultForm()
      this.showDialog = true
    },
    editCompany(row) {
      this.form = { ...defaultForm(), ...row }
      this.showDialog = true
    },
    async submit() {
      try {
        if (this.form.id) {
          await updateCompany(this.form.id, this.form)
          this.$message.success('企业已更新')
        } else {
          await createCompany(this.form)
          this.$message.success('企业已创建')
        }
        this.showDialog = false
        this.loadData()
      } catch (error) {
        this.$message.error(error.response?.data?.message || '保存失败')
      }
    },
    async removeCompany(row) {
      try {
        await this.$confirm(`确认删除企业 ${row.name}？`, '提示', {
          type: 'warning',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
        })
        await deleteCompany(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error(error.response?.data?.message || '删除失败')
      }
    },
  },
}
</script>
